export const accordionContent = (id: number) => {
  switch (id) {
    case 1:
      return [
        {
          id: 1,
          question: "will_the_warehouse",
          answer: "we_are_working_on_it",
          link: "/",
        },
        {
          id: 2,
          question: "how_to_register",
          answer: "we_are_working_on_it",
          link: "/",
        },
        {
          id: 3,
          question: "how_to_create_account",
          answer: "we_are_working_on_it",
          link: "/",
        },
        {
          id: 4,
          question: "what_days_do_you_ship",
          answer: "we_are_working_on_it",
          link: "/",
        },
      ];
    case 2:
      return [];
    case 3:
      return [];
    case 4:
      return [];
    case 5:
      return [];
    case 6:
      return [];
    default:
      return [];
  }
};
